import {SlaTrackingPage} from '@features/sla-tracking'
import {PermissionType} from '@hconnect/apiclient'
import {PageTitle} from '@hconnect/uikit/src/lib2'
import {UpmPlantProvider, useUpmPlant} from '@hconnect/upm'
import {Stack} from '@mui/material'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useParams} from 'react-router'

import {
  ServiceLevelAgreementsEventName,
  useTrackServiceLevelAgreementsAnalyticsEvent
} from '../../performanceDashboard/helpers'
import {useTranslationPrefix} from '../../shared/hooks'
import {PlantSelectBreadcrumb} from '../components'

type TitleProps = {
  title: React.ReactNode
  breadcrumbs?: React.ReactNode
}

const Title = ({title, breadcrumbs}: TitleProps) => {
  return (
    <Stack>
      {breadcrumbs}
      <PageTitle ml={0}>{title}</PageTitle>
    </Stack>
  )
}

type PathParameter = {
  plantId: string
}

type Props = {
  permission: PermissionType
}

export const ServiceLevelAgreementTrackingDashboard = ({permission}: Props) => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  const upmPlant = useUpmPlant({plantId})
  const plantUpmId = upmPlant.upmId
  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  const trackServiceLevelAgreementsDashboard = useTrackServiceLevelAgreementsAnalyticsEvent()
  useEffect(() => {
    trackServiceLevelAgreementsDashboard(
      ServiceLevelAgreementsEventName.UserEntersServiceLevelAgreementsDashboard,
      {}
    )
  }, [trackServiceLevelAgreementsDashboard])

  return (
    <UpmPlantProvider plantUpmId={plantUpmId}>
      <SlaTrackingPage
        inverted
        titleSlot={
          <Title
            title={t(`${hrocPrefix}.slaDashboard.pageTitle`)}
            breadcrumbs={<PlantSelectBreadcrumb permission={permission} sx={{ml: 0}} />}
          />
        }
      />
    </UpmPlantProvider>
  )
}
